import { ArrowUpRight, Facebook, Instagram } from 'lucide-react'
import { Link } from 'react-router-dom'
import { brand, locations, navItems } from '../data/site'
import { imageSize } from '../data/images'

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-main">
        <div className="footer-intro">
          <Link className="footer-logo" to="/" aria-label="Diamond Suites Ocala home">
            <img src={`${import.meta.env.BASE_URL}images/DiamondSuitesOcalaLogo.gif`} alt="Diamond Suites Ocala" {...imageSize('DiamondSuitesOcalaLogo.gif')} />
          </Link>
          <p>
            A polished home for independent beauty and wellness professionals—and a single Ocala
            destination for personal care.
          </p>
          <div className="footer-socials" aria-label="Social links">
            <a href={brand.facebook} target="_blank" rel="noopener noreferrer" aria-label="Diamond Suites Ocala on Facebook"><Facebook /></a>
            <a href={brand.instagram} target="_blank" rel="noopener noreferrer" aria-label="Diamond Suites Ocala on Instagram"><Instagram /></a>
          </div>
        </div>

        <div className="footer-nav">
          <p className="footer-label">Visit</p>
          {navItems.map((item) => <Link key={item.to} to={item.to}>{item.label}</Link>)}
          <Link to="/news/">News</Link>
        </div>

        <div className="footer-contact">
          <p className="footer-label">Diamond Suites Ocala</p>
          <a href={brand.mapUrl} target="_blank" rel="noopener noreferrer">
            {brand.addressLine1}<br />{brand.addressLine2}
          </a>
          <a href={brand.phoneHref}>{brand.phoneDisplay}</a>
          <a href={`mailto:${brand.email}`}>{brand.email}</a>
          <Link className="text-link text-link--light" to="/contact/">
            Suite inquiries <ArrowUpRight aria-hidden="true" />
          </Link>
        </div>

        <div className="footer-family">
          <p className="footer-label">The Diamond family</p>
          {locations.filter((location) => location.href !== '/').map((location) => (
            <a key={location.name} href={location.href} target="_blank" rel="noopener noreferrer">
              {location.name} <ArrowUpRight aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>

      <div className="container footer-identity">
        <div>
          <strong>Diamond Suites Ocala</strong>
          <span>{brand.addressLine1}, {brand.addressLine2}</span>
        </div>
        <p>08 private suites</p>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} Diamond Suites Ocala. All rights reserved.</span>
          <div>
            <Link to="/privacy-policy/">Privacy Policy</Link>
            <Link to="/salon-etiquette/">Salon Etiquette</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
